<template>
    <div class="section section-index-promo" v-if="indexPromo != null && setup != null">
        <div class="main-promo-images">
            <!-- <div class="day promo-img" :style="'background-image: url(' + indexPromo.index_promo_images.img_day + ')' "> -->
            <div class="day promo-img" v-if="indexPromo.index_promo_images != null">
                <img :src="indexPromo.index_promo_images.img_day" alt="">
            </div>
            <div class="night promo-img" v-if="indexPromo.index_promo_images != null">
                <img :src="indexPromo.index_promo_images.img_night" alt="">
            </div>
        </div>
        <div class="main-page-title">
            <h2>{{setup.index_page_title.desc_light}}<br><span>{{setup.index_page_title.desc_bold}}</span></h2>
        </div>
        <li class="online-book-btn" v-if="setup.site_online_booking_init == 'true'">
            <a href="#" v-scroll-to="{el: '#section-flats', offset: 0}" class="book-link">
                <span>ОНЛАЙН БРОНИРОВАНИЕ</span>
            </a>
        </li>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'indexPromo',
        components: {
        },
        data () {
            return {
            }
        },
        methods: { 
        },
        computed: mapGetters({
            setup: 'loadPageSetup',
            indexPromo: 'loadIndexPromo',
        }),
        beforeCreate() {
        },
        created () {
            
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.indexPromo,
            //     (newValue) => {
            //         if (newValue)
                   
            //     }
            // )
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/index-promo/index-promo.scss';
    @import '@/styles/components/index-promo/index-promo-respond.scss';
</style>